import React from 'react';
import { Box, Typography, Button, Container, CircularProgress, ThemeProvider, CssBaseline } from '@mui/material';
import { Link } from 'react-router-dom';
import { theme } from '../theme/theme';

const PaymentPending: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="sm">
        <Box
          sx={{
            mt: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 4,
            boxShadow: 3,
            borderRadius: 2,
            bgcolor: 'background.paper',
          }}
        >
          <CircularProgress sx={{ mb: 2 }} size={60} />
          <Typography variant="h4" component="h1" gutterBottom sx={{ color: theme.palette.text.primary }}>
            Pago Pendiente
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 3, color: theme.palette.text.secondary }}>
            Tu transacción está pendiente de confirmación. Por favor, espera un momento o revisa el estado en tu cuenta de Mercado Pago.
          </Typography>
          <Button variant="contained" color="primary" component={Link} to="/portal">
            Volver al Portal
          </Button>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default PaymentPending;
